module.exports = "<div class=\"app-spinner\"  *ngIf=\"show\">\n  <div class=\"spinner-container\">\n    <mat-spinner></mat-spinner>\n  </div>\n</div>\n"